export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "es",
    "resource": {
      "countryCode": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de país"])},
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["código de país"])}
      }
    }
  })
}
